import axios from 'axios'
import {API_URL} from '../../constants'
import {cloneDeep} from 'lodash'

const state = {
  agentData: null,
  editingAgent: null,
  isLoading: false,
  error: null,
}

// getters
const getters = {
  isLoggedIn: state => {
    return state.isLoggedIn
  },
  getUser: state => {
    return state.user
  },
}

// actions
const actions = {
  async getAgentData ({ commit, state }) {
    const response = await axios.get(`${API_URL}/api/v3/agents`)
    if (response.data.success) {
      commit('setAgentData', response.data.data)
    }
  },
  saveAgent ({ commit, state, dispatch }) {
    commit('setLoading', true)
    commit('setError', null)

    axios.post(`${API_URL}/api/v3/agents`, state.editingAgent)
      .then(response => {
        dispatch('getAgentData')
        commit('setEditingAgent', null)
        commit('setLoading', false)
      })
      .catch((response) => {
        commit('setError', response.response.data.error.message)
        commit('setLoading', false)
      })
  },
}

// mutations
const mutations = {
  setAgentData (state, data) {
    state.agentData = data
  },
  onFieldChange (state, {field, value}) {
    state.editingAgent[field] = value
  },
  setEditingAgent (state, agent) {
    state.error = null
    if (agent) {
      state.editingAgent = cloneDeep(agent)
    } else {
      state.editingAgent = null
    }
  },
  setLoading (state, value) {
    state.isLoading = value
  },
  setError (state, message) {
    state.error = message
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/staff.js